import React, { useState } from 'react';
import StepsWidget from './StepsWidget';
import CaloriesWidget from './CaloriesWidget';
import StationTempWidget from './StationTempWidget';
import HumidityWidget from './HumidityWidget';
import WeightWidget from './WeightWidget';
import MoodWidget from './MoodWidget';
import GptMiEWidget from './GptMiE';
import InsightsWidget from './InsightsWidget';
import WeatherWidget from './WeatherWidget';
import ExpensePieChart from './ExpensePieChartWidget';
import TimeAtDeskWidget from './TimeAtDeskWidget';
import '../../scss/main.scss'; // Import the styles
//import MusicWidget from './MusicWidget'; // Import the MusicWidget
import CustomModal from './CustomModal'; // Import the custom modal
import WidgetSelector from './WidgetSelector'; // Import the widget selector
import FacebookLikesWidget from './FacebookLikesWidget'; // Import Facebook Likes Widget
import FacebookPostsWidget from './FacebookPostsWidget'; // Import Facebook Posts Widget
import HomeAssistantWidget from './HomeAssistantWidget';

const WidgetManager = ({ data, defaultWidgets, maxWidgets }) => {
  // Map widget names to their respective components and default props
  const widgetMap = {
    StepsWidget: { component: StepsWidget, props: { steps: data.steps } },
    CaloriesWidget: { component: CaloriesWidget, props: { calories: data.caloriesToday } },
    StationTempWidget: { component: StationTempWidget, props: { stationTemp: data.stationTemp } },
    HumidityWidget: { component: HumidityWidget, props: { humidity: data.humidity } },
    WeightWidget: { component: WeightWidget, props: { weight: data.weight } },
    MoodWidget: { component: MoodWidget, props: { mood: data.mood } },
    GptMiEWidget: { component: GptMiEWidget, props: { text: data.text } },
    WeatherWidget: { component: WeatherWidget, props: {} },
    InsightsWidget: { component: InsightsWidget, props: {} },
    ExpensePieChartWidget: { component: ExpensePieChart, props: {} },
    TimeAtDeskWidget: { component: TimeAtDeskWidget, props: { timeAtDesk: data.timeAtDesk } },
    FacebookLikesWidget: { component: FacebookLikesWidget, props: { likes: data.likes } },
    FacebookPostsWidget: { component: FacebookPostsWidget, props: { posts: data.posts } },
    HomeAssistantWidget: { component: HomeAssistantWidget, props: {} },
    // Add other widgets here as needed
  };

  // Define availableWidgets as a list of widget names
  //const availableWidgets = Object.keys(widgetMap);
  const availableWidgets = Object.keys(widgetMap).map((key) => ({
    name: key, // Use widgetMap keys as names
  }));
  

  // Initialize the widgets state with the default widgets
  const [widgets, setWidgets] = useState(() => {
    return defaultWidgets.map((widgetName, index) => ({
      id: index + 1,
      component: widgetMap[widgetName]?.component,
      props: widgetMap[widgetName]?.props,
    }));
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedWidgetIndex, setSelectedWidgetIndex] = useState(null);

  const swapWidgets = (index1, index2) => {
    if (index1 < 0 || index2 < 0 || index1 >= widgets.length || index2 >= widgets.length) {
      return;
    }
    const newWidgets = [...widgets];
    [newWidgets[index1], newWidgets[index2]] = [newWidgets[index2], newWidgets[index1]];
    setWidgets(newWidgets);
  };

  const removeWidget = (index) => {
    if (index < 0 || index >= widgets.length) {
      return;
    }
    const newWidgets = widgets.filter((_, i) => i !== index);
    setWidgets(newWidgets);
  };

  const handleWidgetSelection = (widgetName) => {
    const widgetData = widgetMap[widgetName];
    if (widgetData) {
      const newWidgets = [...widgets];
      newWidgets[selectedWidgetIndex] = {
        id: selectedWidgetIndex + 1,
        component: widgetData.component,
        props: widgetData.props,
      };
      setWidgets(newWidgets);
      setShowModal(false); // Close the modal
      console.log(`Widget selected: ${widgetName}`); // Log selected widget
    } else {
      console.warn(`Widget "${widgetName}" is not available in widgetMap.`);
    }
  };
  


  const handleOpenModal = (index) => {
    setSelectedWidgetIndex(index);
    setShowModal(true);
  };

  return (
    <div className="widget-container">
      {widgets.slice(0, maxWidgets).map((widget, index) => {
        const WidgetComponent = widget.component;
        // Derive current props from widgetMap so data changes propagate without a separate effect
        const widgetName = Object.keys(widgetMap).find(
          (key) => widgetMap[key].component === widget.component
        );
        const currentProps = widgetMap[widgetName]?.props ?? widget.props;
        return (
          <div className="widget-row" key={widget.id}>
            <div className="widget">
              <div className="widget-buttons">
                <button className="widget-button" onClick={() => handleOpenModal(index)} title="Change widget">
                  +
                </button>
                <button className="widget-button" onClick={() => removeWidget(index)} title="Remove widget">
                  −
                </button>
              </div>
              <WidgetComponent {...currentProps} />
            </div>
          </div>
        );
      })}
      <CustomModal show={showModal} onClose={() => setShowModal(false)}>
        <WidgetSelector
          widgets={availableWidgets}
          onSelect={handleWidgetSelection}
        />
      </CustomModal>
    </div>
  );
};

export default WidgetManager;
